

const middlewareChain = dispatch => {
}

export default middlewareChain
